import React from 'react';
import { FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';
import { useFetchWithCache } from '../hooks/useFetchWithCache';
import {
  FooterWrap, Inner, BrandBlock, ColTitle, LinkCol, FLink, ContactCol, Bottom,
} from './styles/Footer.styles';

const Footer = () => {
  const { data: contact } = useFetchWithCache('/contact');
  const { data: companies } = useFetchWithCache('/companies');

  const topCompanies = Array.isArray(companies)
    ? [...companies]
        .filter(c => c && (c.isPublished === undefined || c.isPublished))
        .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))
        .slice(0, 5)
    : [];

  return (
    <FooterWrap>
      <Inner>
        <BrandBlock>
          <div className="mark">
            <div className="dot">E</div>
            <div className="name">Ehcerex</div>
          </div>
          <p>
            A diversified group of companies delivering excellence across manufacturing,
            financial services, telecommunications, hospitality, aviation, agriculture,
            education, health and more.
          </p>
        </BrandBlock>

        <LinkCol>
          <ColTitle>Explore</ColTitle>
          <ul>
            <li><FLink to="/">Home</FLink></li>
            <li><FLink to="/about">About Us</FLink></li>
            <li><FLink to="/team">Our Team</FLink></li>
            <li><FLink to="/contact">Contact</FLink></li>
            <li><FLink to="/admin/login">Admin</FLink></li>
          </ul>
        </LinkCol>

        <LinkCol>
          <ColTitle>Companies</ColTitle>
          <ul>
            {topCompanies.length === 0 && <li style={{ color: 'rgba(255,255,255,0.45)' }}>Coming soon</li>}
            {topCompanies.map(c => (
              <li key={c.id || c.slug}>
                <FLink to={`/companies/${c.slug}`}>{c.menuLabel || c.title}</FLink>
              </li>
            ))}
          </ul>
        </LinkCol>

        <ContactCol>
          <ColTitle>Get In Touch</ColTitle>
          {contact?.address && (
            <div><FaMapMarkerAlt /> <span>{contact.address}</span></div>
          )}
          {Array.isArray(contact?.phones) && contact.phones.map((p, i) => (
            <div key={i}><FaPhone /> <span>{p}</span></div>
          ))}
          {contact?.email && (
            <div><FaEnvelope /> <span>{contact.email}</span></div>
          )}
        </ContactCol>
      </Inner>

      <Bottom>
        <div>&copy; {new Date().getFullYear()} <span>Ehcerex Group of Companies</span>. All rights reserved.</div>
        <div>Crafted with precision.</div>
      </Bottom>
    </FooterWrap>
  );
};

export default Footer;
